import {
	validatePartnerLookupResponse,
	validateTwGamingLookupsResponse,
} from "@utils/lookups/validators";
import { sortByNameLocale } from "@utils/lookups/mapper";
import { getIsoFromSupportedLanguages } from "@utils";
import { LookupItem } from "@data-types";
import { THEME_SETTINGS } from "@theme-settings";
import {
	CountryDataType,
	GamingLimitDataType,
	LanguageDataType,
	RegionDataType,
} from "@data-types/membership/registration";
import { TwGamingLimitsApiService } from "@api-services/agency";
import { PlatformPartnerLookupApiService } from "@api-services/platform";
import { logger } from "@utils/logger/logger";

class PartnerLookupService {
	static async getTitles(): Promise<LookupItem[]> {
		try {
			const response = await PlatformPartnerLookupApiService.findTitles();

			const isValid = validatePartnerLookupResponse(
				response,
				"getTitles"
			);

			return isValid ? response : [];
		} catch (error) {
			logger.logError(error);
			return [];
		}
	}

	static async getCountries(): Promise<CountryDataType[]> {
		try {
			const response =
				await PlatformPartnerLookupApiService.findCountries();

			const isValid = validatePartnerLookupResponse(
				response,
				"getCountries"
			);

			if (isValid) {
				const sorted = sortByNameLocale(response);
				return sorted;
			}

			return [];
		} catch (error) {
			logger.logError(error);
			return [];
		}
	}

	static async getLanguages(): Promise<LanguageDataType[]> {
		try {
			const response =
				await PlatformPartnerLookupApiService.findLanguages(
					getIsoFromSupportedLanguages()
				);

			const isValid = validatePartnerLookupResponse(
				response,
				"getLanguages"
			);

			if (isValid) {
				const sorted = sortByNameLocale(response);
				return sorted;
			}

			return [];
		} catch (error) {
			logger.logError(error);
			return [];
		}
	}

	static async getCountryRegions(
		countries?: CountryDataType[]
	): Promise<RegionDataType[]> {
		try {
			let filterCountryId: string | undefined;

			if (THEME_SETTINGS.countryRegionFilterAbrv) {
				const filterCountry = countries?.find(
					(c) => c.abrv === THEME_SETTINGS.countryRegionFilterAbrv
				);
				filterCountryId = filterCountry?.id;
			}

			const response =
				await PlatformPartnerLookupApiService.findCountryRegions(
					filterCountryId
				);

			const isValid = validatePartnerLookupResponse(
				response,
				"getCountryRegions"
			);

			if (isValid) {
				const sorted = sortByNameLocale(response);
				return sorted;
			}

			return [];
		} catch (error) {
			logger.logError(error);
			return [];
		}
	}

	static async getGamingLimits(): Promise<GamingLimitDataType | null> {
		try {
			const response = await TwGamingLimitsApiService.findGamingLimits();

			const isValid = validateTwGamingLookupsResponse(response);

			return isValid ? response : null;
		} catch (error) {
			logger.logError(error);
			return null;
		}
	}
}

export default PartnerLookupService;
